import { render, staticRenderFns } from "./AddAttr.vue?vue&type=template&id=a7eea056&scoped=true"
import script from "./AddAttr.vue?vue&type=script&lang=ts"
export * from "./AddAttr.vue?vue&type=script&lang=ts"
import style0 from "./AddAttr.vue?vue&type=style&index=0&id=a7eea056&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7eea056",
  null
  
)

export default component.exports